import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import { connect } from 'react-redux'
import { Box, Card, Divider, Grid, IconButton, Typography, Skeleton, useTheme } from '@mui/material'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { showModal } from 'react-redux-modal-provider';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { ButtonBasic, TextInfoTicket } from '../../components';
import ContactosService from '../../services/contactos.service';
import InfContactoService from '../../services/infContacto.service';
import ContactosAction from '../../store/actions/contactos';
import TabCuentaTicket from './tabs/TabCuentaTicket';
import ConsultasService from '../../services/consultas.service';
import TabCuentaConsultas from './tabs/TabCuentaConsultas';
import LogService from '../../services/log.service';
import TabCuentaHistorico from './tabs/TabCuentaHistorico';
import TabContactoDatos from './tabs/TabContactoDatos';
import TabCuentaPreServicio from './tabs/TabCuentaPreServicio';
import TabCuentaDocumentacion from './tabs/TabCuentaDocumentacion';
import FileAdjContactoService from '../../services/fileAdjContacto.service';
import TabCuentaTareas from './tabs/TabCuentaTareas';
import CalendarioV2Service from '../../services/calendarioV2.service';
import usePermisos from '../../hooks/usePermisos';
import ModalConsultaVinculacion from '../../modals/consulta/ModalConsultaVinculacion';
import ModalForzarVinculacion from '../../modals/consulta/ModalForzarVinculacion';
import TabCuentaRecodatorios from './tabs/TabCuentaRecodatorios';
import RecordatorioService from '../../services/recordatorio.service';
import { SocketContext } from '../../context/SocketContext';

function TabPanel({ children, value, index, ...other }) {
  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
      {value === index && (
          <Box sx={{ p: 3 }}>{children}</Box>
      )}
      </div>
  );
}
function a11yProps(index) {
  return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
  };
}

// Componente Skeleton para el panel de contacto
const ContactoSkeleton = ({ isDarkMode }) => (
  <Card sx={{
    background: isDarkMode ? '#2d3a52 !important' : '#fff !important',
    p:2,
    borderRadius:4,
    boxShadow: isDarkMode ? "0px -3px 0px 0px #64B5F6" : "0px -3px 0px 0px #0364ff",
    border: isDarkMode ? '1px solid #3d4a62' : 'none'
  }}>
    <Skeleton variant="circular" width={40} height={40} sx={{ mb: 2, bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
    
    {/* Avatar y nombre */}
    <Box sx={{ display:'flex', justifyContent: 'center', alignItems: 'center',flexDirection: 'column', mb: 3 }}>
      <Skeleton variant="circular" width={50} height={50} sx={{ mb: 2, bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
      <Skeleton variant="text" width="80%" height={40} sx={{ mb: 2, bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
    </Box>

    {/* Información básica */}
    <Box sx={{ mb: 3 }}>
      {[1, 2, 3, 4].map((item) => (
        <Box key={item} sx={{ mb: 1.5 }}>
          <Skeleton variant="text" width="40%" height={20} sx={{ bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
          <Skeleton variant="text" width="60%" height={24} sx={{ bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
        </Box>
      ))}
    </Box>

    <Divider sx={{ mb: 2, bgcolor: isDarkMode ? '#3d4a62' : undefined }} />
    
    {/* Datos personales */}
    <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2, bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
    {[1, 2, 3, 4, 5].map((item) => (
      <Box key={item} sx={{ mb: 1.5 }}>
        <Skeleton variant="text" width="30%" height={20} sx={{ bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
        <Skeleton variant="text" width="70%" height={24} sx={{ bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
      </Box>
    ))}

    {/* Botones */}
    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Skeleton variant="rectangular" width={220} height={40} sx={{ borderRadius: 1, mx: 'auto', bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
      <Skeleton variant="rectangular" width={220} height={40} sx={{ borderRadius: 1, mx: 'auto', bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
    </Box>
  </Card>
);

// Componente Skeleton para las tabs
const TabsSkeleton = ({ isDarkMode }) => (
  <Card sx={{
    background: isDarkMode ? '#2d3a52 !important' : '#fff !important',
    p:2,
    borderRadius:4,
    border: isDarkMode ? '1px solid #3d4a62' : 'none'
  }}>
    {/* Skeleton para las tabs */}
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((tab) => (
          <Skeleton key={tab} variant="rectangular" width={80} height={32} sx={{ borderRadius: 1, bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
        ))}
      </Box>
    </Box>

    {/* Contenido de las tabs */}
    <Box sx={{ p: 3 }}>
      {/* Simulación de tabla o contenido */}
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: 1, mb: 2, bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
        {[1, 2, 3, 4, 5].map((row) => (
          <Skeleton key={row} variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1, mb: 1, bgcolor: isDarkMode ? '#1F2A40' : '#e2e8f0' }} />
        ))}
      </Box>
    </Box>
  </Card>
);

const ContactoFindByIdScreen = ({iniciarContacto}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const permisos = usePermisos();
  const { sockets } = useContext( SocketContext );
  const [value, setValue] = useState(0);
  const {id,type} = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [datosOK, setDatosOk] = useState(false);
  const [datosFaltantes, setDatosFaltantes] = useState(null);
  const [contacto, setContacto] = useState();
  const [contactoImg, setContactoImg] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [consultas, setConsultas] = useState([]);
  const [logs, setLogs] = useState([]);
  const [recordatorios, setRecordatorios] = useState([]);
  const [filesAdj, setFilesAdj] = useState([]);
  const [tareas, setTareas] = useState([]);

  const infContacto = async() => {
    await InfContactoService.getAll({contactoId: id}).then((repp)=>{
      setContactoImg(repp)
    })
  }
  const actualizar = async() =>{
    setIsLoading(true)
    await ContactosService.getById(id,{type}).then((response)=>{
        if(response?.cuentaNubi_c){
            navigate(`/contactos/${response.cuentaNubi_c}/cuenta`);
        }else{
          infContacto()
          iniciarContacto(response)
          setContacto(response)
        }
    })
    .catch((e)=>{
      if(e?.response?.data?.msg){
        navigate('/')
      }
    })
    .finally(()=>{
      setIsLoading(false)
    })
  }
  const actualizarConsultas = async() =>{
    await ConsultasService.getAll({id: contacto?.id_c, webV2: true}).then((resp)=>{
        setConsultas(resp)
    })
  }
  const actualizarHistorico = async() =>{
    await LogService.getAllContacto({contactoId: id}).then((resp)=>{
      setLogs(resp)
    })
  }
  const actualizarFileAdjContacto = async() => {
    await FileAdjContactoService.getAll({contactoId: id}).then((resp)=>{
      setFilesAdj(resp)
    })
  }
  const actualizarTareas = async() =>{
    await CalendarioV2Service.tareasCalendar({contactoId: id}).then((resp)=>{
      setTareas(resp)
    })
  }
  const actualizarRecordatorios = async() =>{
    await RecordatorioService.getAll({contactoId: id}).then((resp)=>{
      setRecordatorios(resp)
    })
  }
  const onGuardar = () =>{
    actualizar();
    actualizarHistorico();
    actualizarFileAdjContacto();
    actualizarTareas();
    actualizarRecordatorios();
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onForzarVinculacion = async() => {
    showModal(ModalForzarVinculacion,{id:id})
  }
  const onConsultarVinculacion = async() => {
    setIsLoading(true);
    await ConsultasService.consultarVinculacion(id).then((respCV)=>{
      console.log({respCV})
      if(respCV?.cuenta){
        setIsLoading(false)
        showModal(ModalConsultaVinculacion,{id:id})
      }
    }).catch(()=>{
      setIsLoading(false)
    })
  }

  useEffect(() => {
    const room = `contacto-${id}`;
    sockets?.emit('joinTicketRoom', room);
    actualizar();
    actualizarHistorico();
    actualizarFileAdjContacto();
    actualizarTareas();
    actualizarRecordatorios();
    document.title = `Contacto #${id}`;

    const onContactoRefresh = () => {
      actualizar();
      actualizarHistorico();
      actualizarFileAdjContacto();
      actualizarTareas();
      actualizarRecordatorios();
    };
    sockets?.on('contactoRefresh', onContactoRefresh);

    return () => {
      sockets?.off('contactoRefresh', onContactoRefresh);
      sockets?.emit('leaveTicketRoom', room);
    };
  }, [id])
  useEffect(() => {
    if(contacto?.id_c){
      actualizarConsultas();
    }
  }, [contacto])
  useEffect(() => {
    let textErr = null;
    if((!contacto?.nombreCompleto_c || !contacto?.barrio_c || !contacto.celular_c || !contacto.cobrador_c
        || !contacto.canalcomu_c || !contacto.condicionPago_c || !contacto.cpostal_c || !contacto.direccion_c
        || !contacto.documento_c || !contacto.email_c || !contacto.iva_c || !contacto.latitud_c || !contacto.listPrecio_c
        || !contacto.longitud_c || !contacto.pais_c || !contacto.provincia_c || !contacto.tipoDoc_c
        || !contacto.vendedor_c || !contacto.zona_c
    )){
        setDatosOk(false)
        textErr = 'Datos del contacto'
    }else{
        setDatosOk(true)
    }
    if(contacto?.tipoDoc_c === '80' && !contactoImg?.pathconstanciaAfip_icon){
        setDatosOk(false)
        if(textErr){
          textErr = `${textErr} - Constancia de Afip`
        }else{
          textErr = 'Constancia de Afip'
        }
    }
    /* if(contacto?.tipoDoc_c === '80' && contactoImg?.tipoCuit_icon === 'JURIDICA' && !contactoImg?.pathContratoSocialEstatuto_icon){
      setDatosOk(false)
      if(textErr){
        textErr = `${textErr} - Contrato Social-Estatuto`
      }else{
        textErr = 'Contrato Social-Estatuto'
      }
    } */
    /* if(contacto?.tipoDoc_c === '80' && !contactoImg?.pathDesigActaActualizada_icon){
      setDatosOk(false)
      if(textErr){
        textErr = `${textErr} - Desig. Acta Actualizada`
      }else{
        textErr = 'Desig. Acta Actualizada'
      }
    } */
    /* if(contacto?.tipoDoc_c === '80' && contactoImg?.tipoCuit_icon === 'JURIDICA' && !contactoImg?.pathPoderApoderado_icon){
      setDatosOk(false)
      if(textErr){
        textErr = `${textErr} - Poder-Apoderado`
      }else{
        textErr = 'Poder-Apoderado'
      }
    } */
    /* if(contacto?.tipoDoc_c === '80' && contactoImg?.tipoCuit_icon === 'JURIDICA' && !contactoImg?.pathDniFrenteApoderado_icon){
      setDatosOk(false)
      if(textErr){
        textErr = `${textErr} - Dni-Frente-Apoderado`
      }else{
        textErr = 'Dni-Frente-Apoderado'
      }
    } */
    /* if(contacto?.tipoDoc_c === '80' && contactoImg?.tipoCuit_icon === 'JURIDICA' && !contactoImg?.pathDniDorsoApoderado_icon){
      setDatosOk(false)
      if(textErr){
        textErr = `${textErr} - Dni-Dorso-Apoderado`
      }else{
        textErr = 'Dni-Dorso-Apoderado'
      }
    } */
    if(contacto?.tipoDoc_c === '96' && (!contactoImg?.pathDorso_icon || !contactoImg?.pathFrente_icon)){
        setDatosOk(false)
        if(textErr){
          textErr = `${textErr} - Imagenes del DNI`
        }else{
          textErr = 'Imagenes del DNI'
        }
    }
    setDatosFaltantes(textErr)

  }, [contacto,contactoImg])
  return (
    <Box sx={{width:'100%',height: '100%',overflow:'auto', backgroundColor: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
      <Grid container p={3} mb={5} spacing={1}>
        <Grid item xs={12} md={3}>
          {isLoading ? (
            <ContactoSkeleton isDarkMode={isDarkMode} />
          ) : (
            <Card sx={{
              background: isDarkMode ? '#2d3a52 !important' : '#fff !important',
              p:2,
              borderRadius:4,
              boxShadow: isDarkMode ? "0px -3px 0px 0px #64B5F6" : "0px -3px 0px 0px #0364ff",
              border: isDarkMode ? '1px solid #3d4a62' : 'none'
            }}>
              <IconButton sx={{boxShadow: 3, bgcolor: isDarkMode ? '#1F2A40' : undefined}} onClick={()=>navigate(-1)}>
                <ArrowBackIcon sx={{color: isDarkMode ? '#e0e0e0' : '#000'}} />
              </IconButton>
              <Box sx={{ display:'flex', justifyContent: 'center', alignItems: 'center',flexDirection: 'column'}}>
                <Box sx={{background: isDarkMode ? '#1a3a5c' : '#e6f0ff', borderRadius:50, width:50, height: 50, display:'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <AccountCircleIcon sx={{color: isDarkMode ? '#90caf9' : '#0364ff',fontSize: 40}} />
                </Box>
                <Typography sx={{color: isDarkMode ? '#90caf9' : '#0364ff',fontWeight: 'bold',textAlign: 'center',mb:2}} variant='h4'>{contacto?.nombreCompleto_c}</Typography>
                <TextInfoTicket titulo='Ultimo Estado' descripcion={contacto?.estadoCliente_c} />
                <TextInfoTicket titulo='Total Pre-Servicios' descripcion={contacto?.tratos?.length || '0'} />
                <TextInfoTicket titulo='Total Ticket' descripcion={contacto?.tickets?.length || '0'} />
                { contacto?.contxemp?.length > 0 && (
                  <TextInfoTicket titulo='Categoria' descripcion={contacto?.contxemp[0]?.categoria_cxe || '-'} />
                )}
              </Box>
                <Divider sx={{background: isDarkMode ? '#3d4a62 !important' : '#8993a4 !important',marginBottom:1,width: '100%'}} />
                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold',mb:2}} variant='h5'>Datos personales</Typography>
                <TextInfoTicket titulo='DNI/CUIT' descripcion={contacto?.documento_c || '-'} />
                <TextInfoTicket titulo='Email' descripcion={contacto?.email_c || '-'} />
                <TextInfoTicket titulo='Telefono' descripcion={contacto?.celular_c || '-'} />
                <TextInfoTicket titulo='Domicilio de Facturacion' descripcion={`${contacto?.barrio_c || ''} - ${contacto?.direccion_c || ''}`} />
                {contacto?.coordenadas_c && (
                    <TextInfoTicket titulo='Coordenadas' descripcion={contacto?.coordenadas_c || ''} />
                )}
                {contacto?.asesorHabilitado && (
                  <>
                    <Divider sx={{background: isDarkMode ? '#3d4a62 !important' : '#8993a4 !important',marginY: 1.5,width: '100%'}} />
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold',mb:1.5,fontSize: '0.9rem'}}>Asesor Habilitado</Typography>
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5,
                      p: 1,
                      borderRadius: 2,
                      background: isDarkMode ? 'linear-gradient(135deg, #1a3a5c 0%, #2d4a6e 100%)' : 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                      border: isDarkMode ? '1px solid #3d5a7c' : '1px solid #bae6fd',
                      mb: 1.5
                    }}>
                      <Box sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        overflow: 'hidden',
                        border: isDarkMode ? '2px solid #64B5F6' : '2px solid #0ea5e9',
                        flexShrink: 0
                      }}>
                        {contacto?.asesorHabilitado?.foto_p ? (
                          <img
                            src={contacto.asesorHabilitado.foto_p}
                            alt={contacto.asesorHabilitado.nombre_p}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        ) : (
                          <Box sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: isDarkMode ? '#64B5F6' : '#0ea5e9'
                          }}>
                            <AccountCircleIcon sx={{color: isDarkMode ? '#1F2A40' : '#fff', fontSize: 28}} />
                          </Box>
                        )}
                      </Box>
                      <Box sx={{flex: 1}}>
                        <Typography sx={{
                          color: isDarkMode ? '#90caf9' : '#0369a1',
                          fontWeight: 700,
                          fontSize: '0.85rem',
                          lineHeight: 1.2,
                          mb: 0.25
                        }}>
                          {contacto.asesorHabilitado.nombre_p}
                        </Typography>
                        <Typography sx={{
                          color: isDarkMode ? '#b0bec5' : '#64748b',
                          fontSize: '0.75rem',
                          fontWeight: 500
                        }}>
                          {contacto.asesorHabilitado.puesto_p}
                        </Typography>
                      </Box>
                    </Box>
                    <TextInfoTicket titulo='Email' descripcion={contacto.asesorHabilitado.email_p || '-'} />
                    <TextInfoTicket titulo='DNI' descripcion={contacto.asesorHabilitado.dni_p || '-'} />
                  </>
                )}
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',flexDirection: 'column', mt: 2}}>
                  { permisos['vincular.potClienteToCuenta'] && (
                    <ButtonBasic
                      variant="wk"
                      sx={{width: 220,fontWeight: 'bold', border:1,borderColor: '#0364ff'}}
                      color='nextWhite'
                      textButton='Consultar Vinculación'
                      isLoading={isLoading}
                      onClick={()=>onConsultarVinculacion()}
                    />
                  )}
                  { permisos['vincular.forzosa.potClienteToCuenta'] && (
                    <ButtonBasic
                      variant="wk"
                      sx={{width: 220,fontWeight: 'bold', border:1,borderColor: '#0364ff',mt: 2}}
                      color='nextWhite'
                      textButton='Forzar Vinculación'
                      isLoading={isLoading}
                      onClick={()=>onForzarVinculacion()}
                    />
                  )}
                </Box>
            </Card>
          )}
        </Grid>
        <Grid item xs={12} md={9}>
          {isLoading ? (
            <TabsSkeleton isDarkMode={isDarkMode} />
          ) : (
            <Card sx={{
              background: isDarkMode ? '#2d3a52 !important' : '#fff !important',
              p:2,
              borderRadius:4,
              border: isDarkMode ? '1px solid #3d4a62' : 'none'
            }}>
              <Box sx={{ borderBottom: 1, borderColor: isDarkMode ? '#3d4a62' : '#6b788e' }}>
                  <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                      variant="scrollable"
                      sx={{
                          '& .MuiTabs-indicator':{
                              background: isDarkMode ? '#90caf9' : '#0364ff'
                          },
                          '& .MuiButtonBase-root':{
                            color: isDarkMode ? '#b0bec5' : '#6b788e',
                            fontWeight: 'bold'
                          },
                          '& .MuiButtonBase-root.Mui-selected':{
                              color: isDarkMode ? '#90caf9' : '#0364ff'
                          }
                      }}
                  >
                      <Tab label="Tickets" {...a11yProps(0)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                      <Tab label="Consultas" {...a11yProps(1)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                      <Tab label="Pre-Servicios" {...a11yProps(2)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                      <Tab label="Datos" {...a11yProps(3)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                      <Tab label="Historico" {...a11yProps(4)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                      <Tab label="Documentación" {...a11yProps(5)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                      <Tab label="Tareas" {...a11yProps(6)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                      <Tab label="Recordatorios" {...a11yProps(7)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                  </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <TabCuentaTicket
                  preservicio={id}
                  nombreCompleto={contacto?.nombreCompleto_c}
                  onGuardar={onGuardar}
                  mostrarFiltroServicio
                />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <TabCuentaConsultas
                  consultas={consultas}
                  actualizar={actualizarConsultas}
                  actualizarRecordatorios={actualizarRecordatorios}
                />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <TabCuentaPreServicio preServicios={contacto?.tratos} datosOK={datosOK} datosFaltantes={datosFaltantes} contacto={contacto} onGuardar={onGuardar} />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <TabContactoDatos contacto={contacto} onGuardar={onGuardar} />
              </TabPanel>
              <TabPanel value={value} index={4}>
                <TabCuentaHistorico
                  historico={logs}
                  infoCliente={{ contactoId: id,type: 'nubicom'}}
                  onGuardar={actualizarHistorico}
                />
              </TabPanel>
              <TabPanel value={value} index={5}>
                <TabCuentaDocumentacion infoIni={contactoImg} filesAdj={filesAdj} token={token} onGuardar={onGuardar} consulta={{id_c: id}} />
              </TabPanel>
              <TabPanel value={value} index={6}>
                <TabCuentaTareas tareas={tareas} traerTareas={actualizarTareas} />
              </TabPanel>
              <TabPanel value={value} index={7}>
                <TabCuentaRecodatorios
                  recordatoriosAll={recordatorios}
                  contactoId={id}
                  nombreCompleto={contacto?.nombreCompleto_c}
                  onGuardar={actualizarRecordatorios}
                />
              </TabPanel>
            </Card>
          )}
        </Grid>
      </Grid>
    </Box>
  )
}
const mapStateToProps = (state) => ({
  contacto: state.contactos.current,
})

const mapDispatchToProps = (dispatch) => ({
  iniciarContacto: (data) => dispatch(ContactosAction.iniciarContacto(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ContactoFindByIdScreen)